/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import styled from 'styled-components';

import { RadioWrapper, RadioLabel, Radio } from './common';
import Required from './common/Required';

const RadioButton = (props) => {
  const { field, label, value, required, description } = props;
  const { name } = field;

  return (
    <>
      <RadioWrapper name={name}>
        <Radio type="radio" {...field} value={value} id={name} />
        <span data-type="radio" />
        <RadioLabel>
          {label} <Required required={required} />
        </RadioLabel>
      </RadioWrapper>
      {description && <StyledDescription>{description}</StyledDescription>}
    </>
  );
};

const StyledDescription = styled.p`
  display: block;
  color: var(--gray-dark);
  font-size: var(--font-size-sm);
  margin-bottom: 10px;
  margin-left: 30px;
`;

export default RadioButton;
